import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledItemsContainer = styled(FlexBox)`
    height: 100%;
`;

export const StyledTabItem = styled.div<{ disabled?: boolean; isSelected: boolean }>`
    line-height: 17px;
    font-weight: 500;
    font-size: 14px;
    height: 100%;
    display: flex;
    align-items: center;
    caret-color: transparent;
    font-family: ${({ theme }) => theme.fonts.text};
    color: ${({ theme, isSelected }) => (isSelected ? theme.colors.purple : theme.colors.warmBlack)};
    position: relative;

    &:hover {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.purple};
    }

    ${({ disabled }) =>
        disabled &&
        css`
            color: ${({ theme }) => theme.colors.gs300};
            cursor: default;

            &:hover {
                color: ${({ theme }) => theme.colors.gs300};
            }
        `};

    & + & {
        margin-left: 15px;
    }

    &::after {
        content: '';
        width: 100%;
        display: ${({ isSelected }) => (isSelected ? 'block' : 'none')};
        background: ${({ theme }) => theme.colors.purple};
        height: 1px;
        position: absolute;
        bottom: 0;

        ${media.sm`
            height: 2px;
        `}
    }

    ${media.sm`
        font-size: 16px;
        line-height: 19px;
    
        & + & { 
          margin-left: 15px; 
        }
    `}
`;
